const Web3 = require("web3");

const FALLBACK_RPC = 
// "https://bsc-testnet.infura.io/v3/bcb2eb9ea56148be9bda068196cd50c7"; //BSC Testnet
// 'https://mainnet.infura.io/v3/7473fbc3ac8a4ea9a00e3cf2a7f30125'; // Ethereum Mainnet
//   'https://sepolia.infura.io/v3/7473fbc3ac8a4ea9a00e3cf2a7f30125'; //Ethereum Sepolia Testnet
//   "https://polygon-mainnet.infura.io/v3/7473fbc3ac8a4ea9a00e3cf2a7f30125"; //Polygon Mainnet
// "https://polygon-amoy.infura.io/v3/7473fbc3ac8a4ea9a00e3cf2a7f30125"; //Polygon Amoy Testnet
'https://bsc-testnet.infura.io/v3/d15926cc7ccc47e1be41bcf7f503cc1d'

let web3;
const hasInjectedEthereum = typeof window !== "undefined" && Boolean(window.ethereum);

if (hasInjectedEthereum) {
  web3 = new Web3(window.ethereum);
} else {
  web3 = new Web3(FALLBACK_RPC);
}

if (typeof window !== "undefined") {
  window.web3 = web3;

  // Function to seamlessly bind window.ethereum whenever it gets injected
  const syncProvider = (provider) => {
    if (provider && web3) {
      try {
        web3.setProvider(provider);
        window.web3 = web3;
      } catch (e) {
        console.warn("[web3] Error setting provider:", e);
      }
    }
  };

  // 1. Listen for ethereum#initialized event (MetaMask injection event)
  window.addEventListener(
    "ethereum#initialized",
    () => {
      if (window.ethereum) {
        syncProvider(window.ethereum);
      }
    },
    { once: true }
  );

  // 2. Short-interval polling fallback for providers that don't fire ethereum#initialized
  if (!window.ethereum) {
    let checkCount = 0;
    const intervalId = setInterval(() => {
      checkCount++;
      if (window.ethereum) {
        syncProvider(window.ethereum);
        clearInterval(intervalId);
      } else if (checkCount >= 30) {
        clearInterval(intervalId);
      }
    }, 50);
  }

  // 3. Safe getAccounts wrapper with 1.5s timeout watchdog to guarantee no hangs on RPC calls
  if (web3 && web3.eth) {
    const originalGetAccounts = web3.eth.getAccounts.bind(web3.eth);
    web3.eth.getAccounts = async function (...args) {
      // If window.ethereum is available, query injected wallet first
      if (window.ethereum && window.ethereum.request) {
        try {
          const timeoutPromise = new Promise((resolve) =>
            setTimeout(() => resolve([]), 1500)
          );
          const ethAccountsPromise = window.ethereum.request({
            method: "eth_accounts",
          });
          const res = await Promise.race([ethAccountsPromise, timeoutPromise]);
          if (Array.isArray(res) && res.length > 0) {
            return res;
          }
        } catch (err) {
          // fallback to web3 call
        }
      }

      try {
        const timeoutPromise = new Promise((resolve) =>
          setTimeout(() => resolve([]), 1500)
        );
        const originalPromise = originalGetAccounts(...args);
        return await Promise.race([originalPromise, timeoutPromise]);
      } catch (e) {
        return [];
      }
    };
  }
}

export default web3;
